import type { ProgramsFilterSelections, ProgramsSortSelection } from '@makemydeal/dr-dash-types';
import type { OfferType } from '@makemydeal/dr-platform-types';
import { SET_PROGRAMS_FILTERS, SET_PROGRAMS_SORT } from '../actionTypes/programsPreferencesActionTypes';

export const setProgramsFilters = (offerType: OfferType, filters: ProgramsFilterSelections) => ({
    type: SET_PROGRAMS_FILTERS,
    payload: { offerType, filters }
});

export const setProgramsSort = (offerType: OfferType, sort: ProgramsSortSelection | null) => ({
    type: SET_PROGRAMS_SORT,
    payload: { offerType, sort }
});
